// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1CWrk","col":"styles_col__3fHNm"};